import { ChangeEvent, ReactNode } from 'react';
import { withStyles } from '../../../utils';
import styles from './CardCheckbox.module.scss';
import SwitchIndicator from '../../Atomic/SwitchIndicator';
import CheckboxIndicator from './CheckboxIndicator';
import { useDatadogLog } from '../logging';

const cn = withStyles(styles);

type State = boolean | 'indeterminate';

type CardCheckboxProps = {
  name: string;
  checked: State;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  label: ReactNode;
  labelPosition?: 'left' | 'right';
  indicator?: 'checkbox' | 'switch';
  className?: string;
  renderLabelStart?: (args: { checked: State }) => ReactNode;
  renderLabelEnd?: (args: { checked: State }) => ReactNode;
};

export default function CardCheckbox({
  name,
  onChange = () => {},
  checked,
  disabled = false,
  label,
  labelPosition = 'left',
  indicator = 'checkbox',
  className,
  renderLabelStart,
  renderLabelEnd,
}: CardCheckboxProps) {
  const id = `checkbox-${name}`;
  const log = useDatadogLog();

  return (
    <label className={cn('cardCheckboxContainer', `label-${labelPosition}`, className)} htmlFor={id}>
      <span className={cn('labelContainer')}>
        {renderLabelStart && renderLabelStart({ checked })}
        <div className={cn('label')}>{label}</div>
        {renderLabelEnd && renderLabelEnd({ checked })}
      </span>

      <input
        id={id}
        type="checkbox"
        name={name}
        checked={checked === 'indeterminate' ? true : checked}
        onChange={(e) => {
          onChange(e);
          log({
            message: `${name} was toggled`,
            payload: { name, value: checked },
            actionType: 'Option',
          });
        }}
        disabled={disabled}
        className={cn('input')}
        data-testid={id}
      />

      {indicator === 'switch' ? (
        <SwitchIndicator
          checked={checked === 'indeterminate' ? true : checked}
          disabled={disabled}
          className={cn('indicator', disabled && 'disabled')}
        />
      ) : (
        <CheckboxIndicator
          checked={checked}
          disabled={disabled}
          containerClassName={cn('indicator', disabled && 'disabled')}
        />
      )}
    </label>
  );
}
